//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  
  props: {
    article: {},
  },
  data() {
    return {
      row: {},
      ean: "",
      quantity: 1, // CHANGE THIS IN FUTURE TO SUPPORT QUANTITY ON BARCODE
      barcodeId: 0,
      showDialog:false,
      busy:false,
      pagination: {
         page: 1,    
         rowsPerPage: 0 // 0 means all rows    
     },
     columns: [     
        {
          name: "ean",
          align: "left",
          label: "EAN",
          field: "ean",
        }
     ],
    }
  },
  methods: {
    onCreateClick() {
     this.clearForm();
      this.showDialog = true;
    },

    onRowClick(evt, row) {
      this.row = row;
      this.ean = row.ean;
      this.quantity = row.quantity;
      this.barcodeId = row.id;
      this.showDialog = true;      
    },

    async createOrUpdateBarcode(){      
      var barcode = {};
      barcode.ean = this.ean;
      barcode.quantity = this.quantity;
      barcode.id = this.barcodeId;
      barcode.productId = this.article.id;
      
      if(barcode.id != 0){ // update      
          var objIndex = this.article.barcodes.findIndex((obj => obj.id == barcode.id));
          this.$set(this.article.barcodes, objIndex, barcode)  
      }
      else{  //new
        barcode.id = Math.floor((Math.random() * -1000000) + 1); // hack to get a unique id.
        this.article.barcodes.push(barcode);
      }      

      this.clearForm();    
    },

    clearForm(){
      this.row = {};
      this.ean = "";
      this.quantity = 1;
      this.barcodeId = 0;
      this.showDialog = false;
    },

    async deleteClick(){
      this.article.barcodes =this.article.barcodes.filter(barcode => barcode.id !== this.barcodeId); 
      this.clearForm();
    },
  },
};
